import { Auth0Provider } from '@auth0/auth0-react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import CONFIG from '../Services/CONFIG';
import keycloak from '../Services/KeyCloack';
import { AuthProvider } from './AuthProvider';

export const AppProviders = ({ children }) => {
  const app = <AuthProvider>{children}</AuthProvider>;

  if (CONFIG.AUTH_PROVIDER === 'keycloak') {
    return (
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{
          onLoad: 'login-required',
          pkceMethod: 'S256',
          checkLoginIframe: false,
        }}
      >
        {app}
      </ReactKeycloakProvider>
    );
  }

  if (CONFIG.AUTH_PROVIDER === 'auth0') {
    return (
      <Auth0Provider
        domain={CONFIG.AUTH0_DOMAIN}
        clientId={CONFIG.AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: CONFIG.AUTH0_AUDIENCE,
        }}
        cacheLocation="localstorage" //need for inkognito
        // cacheLocation="memory" //default value lost every time the page is refreshed
        // useRefreshTokens={true}
      >
        {app}
      </Auth0Provider>
    );
  }

  return app;
};
